import Vue from 'vue';
import { Component, Prop, Watch, Emit } from 'vue-property-decorator';

@Component({
  components: {
    FormInput: () => import('@/components/forms/Input.vue'),
  },
})
export class Section extends Vue {
  @Prop({ default: true }) forceOpen!: boolean;

  @Prop({ default: true }) defaultLanguageSelected!: boolean;

  localValue: any = undefined;

  open: boolean = true;

  get localeDisabledClasses() {
    return { 'pointer-events-none opacity-50': !this.defaultLanguageSelected };
  }

  private openSection() {
    this.open = true;
  }

  private closeSection() {
    this.open = false;
  }

  @Watch('value', { immediate: true, deep: true })
  private updateLocalvalue(value: any) {
    this.localValue = value;
  }

  @Watch('forceOpen', { immediate: true })
  private handleForceOpen(value: boolean) {
    if (value) {
      this.open = true;
    } else {
      this.open = false;
    }
  }

  @Emit('input')
  private onValueChange() {
    return this.localValue;
  }
}
